<dialog-gala (clickClose)="retour()">
    <span gala-dialog-titre>{{translate.instant("INCARNATION.TITRE")}}</span>

    <div class="row mb-3">
        <div class="col-md-12">
            <input-gala [ngModel]="recherche()" (ngModelChange)="recherche.set($event)"
                [placeholder]="translate.instant('INCARNATION.RECHERCHE')" icone="fas fa-search prefix" />
        </div>
    </div>

    @if (chargement()) {
        <div class="row">
            <div class="col-md-12 text-center mt-4">
                <mat-spinner class="mx-auto" diameter="32" />
            </div>
        </div>
    } @else if (utilisateursFiltres().length === 0) {
        <div class="row">
            <div class="col-md-12 mt-4">{{translate.instant("INCARNATION.AUCUNRESULTAT")}}</div>
        </div>
    } @else {
        <table class="table table-striped">
            <tbody>
                @for (utilisateur of utilisateursFiltres(); track utilisateur.USRID) {
                    <tr class="ligne-utilisateur" [class.ligne-selectionnee]="selection() === utilisateur"
                        (click)="selectionner(utilisateur)">
                        <td>{{utilisateur.NOM}}</td>
                        <td>{{utilisateur.PRENOM}}</td>
                    </tr>
                }
            </tbody>
        </table>
    }

    <div gala-dialog-actions>
        <button mat-stroked-button color="primary" type="button" [disabled]="!selection() || enCours()"
            (click)="seConnecter()">{{translate.instant("INCARNATION.BOUTON")}}</button>
        <button mat-stroked-button color="accent" type="button" (click)="retour()">{{translate.instant("INCARNATION.RETOUR")}}</button>
    </div>
</dialog-gala>
